import { Ref } from 'react'

interface ReviewTransactionsIconProps {
  magnifyingGlassRef?: Ref<SVGGElement>
  className?: string
}

export const ReviewTransactionsIcon = ({
  magnifyingGlassRef,
  className,
}: ReviewTransactionsIconProps) => (
  <svg
    width="81"
    height="80"
    viewBox="0 0 81 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Notepad, stays still */}
    <g>
      <path
        d="M6.63853 7.875C6.60068 9.96251 6.63853 13.1102 6.63853 15.4307V15.722C6.63853 19.4044 6.63853 23.3725 6.63853 27.366C6.63853 29.3931 6.5993 31.4974 6.63853 33.5423C7.13415 59.381 12.3732 65.9131 15.3178 73.9997H73.3513C70.4923 60.7135 63.2033 48.7318 63.2033 21.2288C63.16 19.6283 63.2033 17.998 63.2033 16.3486C63.2033 13.6576 63.2245 10.2203 63.2166 7.875H6.63853Z"
        fill="white"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
      <path
        d="M8.55454 5C8.51669 7.08751 8.55454 10.2352 8.55454 12.5557V12.847C8.55454 16.5294 8.55454 20.4975 8.55454 24.491C8.55454 26.5181 8.51532 28.6224 8.55454 30.6673C9.05017 56.506 14.2892 63.0381 17.2338 71.1247H75.2674C72.4083 57.8385 65.1194 45.8568 65.1194 18.3538C65.076 16.7533 65.1194 15.123 65.1194 13.4736C65.1194 10.7826 65.1405 7.3453 65.1326 5H8.55454Z"
        fill="white"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
      <path
        d="M13.245 9.60938C13.2134 11.3963 13.245 13.2703 13.245 15.2566V15.506C13.245 17.0286 13.245 18.6082 13.245 20.2198C13.245 21.9446 13.245 23.706 13.245 25.4732C13.245 27.2084 13.2123 29.0097 13.245 30.7602C13.2776 32.4979 13.3378 34.1335 13.4224 35.6759C13.5249 37.5457 13.6632 39.2783 13.8313 40.8892C14.0625 43.1045 14.35 45.0896 14.6782 46.8845C15.0741 49.0492 15.5293 50.9372 16.0164 52.6191C16.6582 54.8349 17.3555 56.6928 18.0459 58.3537C19.1374 60.9799 20.2117 63.1137 21.0217 65.3917H69.5341C69.04 63.0404 68.3876 60.7368 67.6635 58.3537C67.1031 56.5095 66.4998 54.6176 65.8936 52.6191C65.3448 50.8096 64.7937 48.9126 64.27 46.8845C63.7859 45.0097 63.3252 43.0228 62.9116 40.8892C62.5927 39.2439 62.3016 37.5114 62.0494 35.6759C61.8348 34.1151 61.6483 32.4798 61.4964 30.7602C61.3481 29.0812 61.2328 27.3219 61.1568 25.4732C61.0878 23.7978 61.051 22.0489 61.051 20.2198C61.0148 18.8498 61.051 17.4542 61.051 16.0423C61.051 13.7388 61.0687 11.617 61.0621 9.60938H13.245Z"
        fill="white"
      />
      <path
        d="M13.245 25.4732C13.245 27.2084 13.2123 29.0097 13.245 30.7602M13.245 25.4732H61.1568M13.245 25.4732C13.245 23.706 13.245 21.9446 13.245 20.2198M13.245 30.7602H61.4964M13.245 30.7602C13.2776 32.4979 13.3378 34.1335 13.4224 35.6759M61.051 20.2198C61.0148 18.8498 61.051 17.4542 61.051 16.0423C61.051 13.7388 61.0687 11.617 61.0621 9.60938H13.245C13.2134 11.3963 13.245 13.2703 13.245 15.2566V15.506C13.245 17.0286 13.245 18.6082 13.245 20.2198M61.051 20.2198C61.051 22.0489 61.0878 23.7978 61.1568 25.4732M61.051 20.2198H13.245M61.1568 25.4732C61.2328 27.3219 61.3481 29.0812 61.4964 30.7602M61.4964 30.7602C61.6483 32.4798 61.8348 34.1151 62.0494 35.6759M13.4224 35.6759H62.0494M13.4224 35.6759C13.5249 37.5457 13.6632 39.2783 13.8313 40.8892M62.0494 35.6759C62.3016 37.5114 62.5927 39.2439 62.9116 40.8892M13.8313 40.8892H62.9116M13.8313 40.8892C14.0625 43.1045 14.35 45.0896 14.6782 46.8845M62.9116 40.8892C63.3252 43.0228 63.7859 45.0097 64.27 46.8845M14.6782 46.8845H64.27M14.6782 46.8845C15.0741 49.0492 15.5293 50.9372 16.0164 52.6191M64.27 46.8845C64.7937 48.9126 65.3448 50.8096 65.8936 52.6191M16.0164 52.6191H65.8936M16.0164 52.6191C16.6582 54.8349 17.3555 56.6928 18.0459 58.3537M65.8936 52.6191C66.4998 54.6176 67.1031 56.5095 67.6635 58.3537M18.0459 58.3537C19.1374 60.9799 20.2117 63.1137 21.0217 65.3917H69.5341C69.04 63.0404 68.3876 60.7368 67.6635 58.3537M18.0459 58.3537H67.6635"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
      <path
        d="M19.954 9.60938C19.9224 11.3963 19.954 13.2703 19.954 15.2566V15.506C19.954 17.0286 19.954 18.6082 19.954 20.2198C19.954 21.9446 19.954 23.706 19.954 25.4732C19.954 27.2084 19.9212 29.0097 19.954 30.7602C19.9866 32.4979 20.0468 34.1335 20.1314 35.6759C20.2339 37.5457 20.3722 39.2783 20.5403 40.8892C20.7715 43.1045 21.059 45.0896 21.3872 46.8845C21.7831 49.0492 22.2382 50.9372 22.7254 52.6191C23.3672 54.8349 24.0645 56.6928 24.7549 58.3537C25.8464 60.9799 26.9206 63.1137 27.7307 65.3917"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
      <path d="M61.0501 15.4297H13.2441" stroke="#1D1D1D" strokeWidth="0.3" />
      <path
        d="M57.4189 65.3783C56.9165 62.4847 56.2531 59.6499 55.5168 56.7173C54.947 54.4477 54.3335 52.1195 53.7171 49.6601C53.1591 47.4333 52.5986 45.0989 52.0661 42.603C51.5739 40.2958 51.1055 37.8507 50.6849 35.2251C50.3606 33.2004 50.0647 31.0684 49.8081 28.8095C49.59 26.8888 49.4003 24.8763 49.2459 22.7602C49.0951 20.694 48.9779 18.529 48.9005 16.254C48.8304 14.1922 48.793 12.04 48.793 9.78906"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
      <path
        d="M42.0829 65.3783C41.5805 62.4847 40.9171 59.6499 40.1808 56.7173C39.611 54.4477 38.9975 52.1195 38.3812 49.6601C37.8231 47.4333 37.2627 45.0989 36.7302 42.603C36.2379 40.2958 35.7696 37.8507 35.349 35.2251C35.0246 33.2004 34.7287 31.0684 34.4722 28.8095C34.2541 26.8888 34.0644 24.8763 33.9099 22.7602C33.7592 20.694 33.6419 18.529 33.5646 16.254C33.4944 14.1922 33.457 12.04 33.457 9.78906"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
    </g>

    {/* Magnifying glass, hovers in a circle over the notepad */}
    <g ref={magnifyingGlassRef}>
      <rect
        x="-0.212203"
        y="0.0124216"
        width="6.14238"
        height="23.2771"
        rx="3.07119"
        transform="matrix(-0.666107 0.745856 -0.748579 -0.663045 71.185 59.3821)"
        fill="#A5D6BF"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
      <rect
        x="0.0123708"
        y="0.211335"
        width="3.89527"
        height="7.56735"
        rx="1.94763"
        transform="matrix(-0.666107 0.745856 0.748579 0.663045 49.3097 41.062)"
        fill="#F0E7D5"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
      <rect
        x="-0.212203"
        y="0.0124216"
        width="6.06027"
        height="2.41211"
        rx="1.20605"
        transform="matrix(-0.666107 0.745856 -0.748579 -0.663045 52.2026 42.4211)"
        fill="#F0E7D5"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
      <path
        d="M34.241 48.9684C44.254 49.5064 52.8109 41.8585 53.3547 31.8876C53.8984 21.9166 46.2231 13.3965 36.2102 12.8585C26.1972 12.3205 17.6402 19.9684 17.0965 29.9393C16.5528 39.9102 24.228 48.4304 34.241 48.9684Z"
        fill="#A5D6BF"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
      <path
        d="M34.4873 46.6823C43.2334 47.1522 50.7076 40.4719 51.1825 31.7627C51.6575 23.0536 44.9534 15.6114 36.2073 15.1415C27.4612 14.6715 19.987 21.3518 19.5121 30.061C19.0372 38.7702 25.7412 46.2123 34.4873 46.6823Z"
        fill="#DEF4E7"
        stroke="#1D1D1D"
        strokeWidth="0.3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6886 32.3321C21.1143 28.7178 25.6241 28.9523 27.6101 32.0263C28.281 33.0648 29.036 34.0839 29.8738 35.0706C30.6042 35.9307 31.3695 36.7331 32.1611 37.4755C34.8299 39.9783 34.2263 44.4345 30.776 43.2172C28.5298 42.4247 26.4584 41.0468 24.8087 39.1041C23.1054 37.0982 22.073 34.7506 21.6886 32.3321Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.9213 22.4317C47.0181 24.0092 44.7887 24.52 43.2929 23.3143C41.7565 22.076 41.7697 19.7324 43.5804 20.5168C44.0275 20.7104 44.456 20.9668 44.8534 21.2871C45.2726 21.625 45.6291 22.0114 45.9213 22.4317Z"
        fill="white"
      />
    </g>
  </svg>
)
